// extracted by mini-css-extract-plugin
module.exports = {"authVkBtn":"style__authVkBtn__1jwYJ","authVkBtnDisabled":"style__authVkBtnDisabled__1-dpI","authVkBtnIcon":"style__authVkBtnIcon__3laqO"};